import { MediaQuery } from "@grandvisionhq/common";
import { getContentByRef } from "./get-content-by-ref.js";
function getPlpPromotionSize(pageModel, breakpoint, refPrefix) {
  if (!pageModel) {
    return {};
  }
  const catalogComponent = Object.values(pageModel.page).find(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (value) => value.label === "Product catalog v2"
  );
  if (!catalogComponent) {
    return {};
  }
  const ref = catalogComponent.models?.document?.$ref;
  const content = getContentByRef(ref, pageModel, refPrefix);
  const { smallPromotion, bigPromotion } = content?.data ?? {};
  const isSmallScreen = breakpoint === MediaQuery.BreakpointName.PHONE;
  const smallPromoSize = smallPromotion ? isSmallScreen ? 2 : 1 : 0;
  const bigPromoSize = bigPromotion ? 2 : 0;
  return { plpPromotionSize: smallPromoSize + bigPromoSize };
}
export {
  getPlpPromotionSize
};
//# sourceMappingURL=get-plp-promotion-size.js.map
